up.viewport.config.fixedTopSelectors.push('.navigation')

up.network.config.progressBar = false
